/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable*/
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { AppEnvConfig } from '../../../app.env.config';
import { User, UserSettings } from '../../../shared/models/User';
import { LocalCacheService } from '../../local-cache/local-cache.service';
import { LoggerService } from '../../logger/global-logger.service';
import { SubheaderHandlerService } from '../../nav/subheader-handler.service';
import { NavigationHandlerService } from './../../../core/nav/navigation-handler.service';
import { FilterNavigation } from './../../../core/pipes/filter-navigation.pipe';
import { UserService } from './../../../core/user/user.service';
import { MenuItems, SelectedMenus } from './../../../menu/contracts/menu';
import { AWSMenusResponse, MenusResponse } from './../../../menu/menus.json';
import { MenusValues } from './../../../menu/models/menu-values';
import { ENVIRONMENTS, USERROLES } from '../../../app.config';

type CloudId = 'aws' | 'azure' | 'gcp' | 'oci';
interface CloudOption { id: CloudId; label: string; active: boolean; targetPath?: string; }

@Component({
    selector: 'nalco-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  user: User;
  authenticated = false;
  menuList: MenusValues;
  toolsMenus: MenuItems[];
  digitalServicesMenu: MenuItems[];
  leftMidNavigationItems: MenuItems[] // to get the original midNavigation Items

  isexpanded = false;

  isEDataEntryNavigation: any;
  isClimateIntelligenceNavigation: any;
  isCrudeFlexEnabled: any;
  isFSQSEnabled: any;
  isCredentialMenuHide : boolean;
  isTotalBoothManagementEnabled : boolean;
  isPaperServiceEnabled : boolean;
  permissions = [];
  returnUrl: string;
  subheaderData = {
    leftSection: {
      type: '',
      data: '',
      className: 'col-lg-6',
      headerClassName: '.no-header-background'
    },
    middleSection: {
      type: '',
      data: [],
      className: ''
    },
    rightSection: {
      type: '',
      data: [],
      className: ''
    }
  };
  hideServicesForAWS: boolean = false;
  azure  = 'azure';
  showCloudInstanceNavigation = false;
  targetCloud = '';
  isFbiOnboardingRoute = false;
  showCloudDropdown = false;
  currentCloudLabel = '';
  cloudOptions: CloudOption[] = [
    { id: 'aws', label: 'AWS', active: false, targetPath: '/app2' },
    { id: 'azure', label: 'Azure', active: false, targetPath: '/app1' },
    { id: 'gcp', label: 'GCP', active: false },
    { id: 'oci', label: 'OCI', active: false },
  ];
  constructor(
    private logger: LoggerService,
    private route: ActivatedRoute,
    private router: Router,
    private cache: LocalCacheService,
    private config: AppEnvConfig,
    private translation: TranslateService,
    private subHeaderService: SubheaderHandlerService,
    private navService: NavigationHandlerService,
    private userService: UserService,
    private cdr: ChangeDetectorRef
  ) {
    this.subheaderData.leftSection.data = '';
    this.subHeaderService.updateLeftSection(this.subheaderData.leftSection);
    this.subHeaderService.updateMiddleSection(this.subheaderData.middleSection);
    this.subHeaderService.updateRightSection(this.subheaderData.rightSection);
    this.cache.storeData('adrumService', 'Home', 'local');
    this.cache.storeData('adrumHeader', '', 'local');
    this.cache.storeData('adrumComponent', "HomeComponent", 'local');
    this.cache.storeData('adrumElement', '', 'local');
    this.cache.storeData('sitename', '', 'local');
    this.isEDataEntryNavigation = config.getEnv('isEDataEntryNavigation').toString();
    this.isClimateIntelligenceNavigation = config.getEnv('isClimateIntelligenceNavigation').toString();
    this.isCrudeFlexEnabled = config.getEnv('isCrudeFlexEnabled').toString();
    this.isCredentialMenuHide = config.getEnv('isCredentialMenuHide');
    this.isFSQSEnabled = config.getEnv('isFSQSEnabled');
    this.isTotalBoothManagementEnabled = config.getEnv('isTotalBoothManagementEnabled');
    this.isPaperServiceEnabled = config.getEnv('isPaperServiceEnabled');
  }




  ngOnInit() {

    // not sending query param from guard, now using cache
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.logger.info({ message: 'login component init' }, false, true);
    this.cache.clearData('sitename', 'local');
    this.cache.clearData('corporateAccountName', 'local');
    this.cache.clearData('navigateDV', 'local');
    this.cache.clearData('AH_DefaultDashboard');
    this.hideServicesforAWSInstance();
    this.setCloudNavigationVisibility();
    this.getUserSettings();
    this.user = JSON.parse(this.cache.fetchData('msalUserInfo'));
    this.isFbiOnboardingRoute = this.router.url.startsWith('/food-and-beverage-intelligence/onboarding')
            || this.router.url.startsWith('/food-and-beverage-intelligence/opportunities');
    if (this.userService.userInfo) {
      this.returnUrl = this.returnUrl || this.cache.fetchData('returnUrl', 'local');
      // allow redirect from login only for the first time after receiving id token
      if (this.returnUrl && this.returnUrl.length > 1) {
        //this.router.navigateByUrl(decodeURIComponent(this.returnUrl));
      }

    } else {
      // this.msalJsService.login();
      /*
      this.cache.storeData('returnUrl', this.returnUrl, 'local');
     */
    }
  }


  filterByUserRole(role, navigationDetail, linksToExclude: string[]) {
    const userSettings = this.userService.getCurrentSettings();
    const isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
    let navigationMenu = [];
    if (role !== null) {
      const pipe = new FilterNavigation();
      const UserRegion = userSettings ? userSettings.UserPreference.UserRegion : null;
        navigationMenu = pipe.transform(role, navigationDetail,userSettings.IsInternalUser, isE3DChina, linksToExclude, UserRegion);
      return navigationMenu;
    } else {
      return navigationMenu;
    }
  }

  /**
   * @description Gets list of links to exclude
   * @returns string of links to exclude
   */
  getLinksToExclude(): string[] {
    const isNewFiRefreshEnabled: boolean = this.config.getEnv('isNewFiRefreshEnabled') === "true";
    const excludeLinks = isNewFiRefreshEnabled ? ['/financial-impact/admin'] : [];

    return excludeLinks;
  }

  getUserSettings() {
    const userSettings = this.userService.getCurrentSettings();
    if (userSettings.Permissions) {
      this.permissions = userSettings.Permissions;
    }
    // const userCulture = userSettings.Culture.match(/en|es|pt|zh|de|nl|fr|ru/);
    // const userLanguage = userCulture != null ? userCulture[0] : 'en';


    const role = this.userService.getUserRole();
    const userPermissions = [];
    if (role !== null) {
      role.forEach(function (s) {
        userPermissions.push(s.PermissionId.toString());
      });
    }
    const MenuItemsArray = this.hideServicesForAWS == true ? JSON.parse(JSON.stringify(AWSMenusResponse)) : JSON.parse(JSON.stringify(MenusResponse));
    this.menuList = MenuItemsArray;
    const env = environment.environment;
    if (!this.hideServicesForAWS && env === ENVIRONMENTS.prod) {
      this.menuList = MenuItemsArray;
      this.menuList.leftMidNavigation.forEach((s => {
        if (s.label === 'LEFT_NAV.MAIN_NAV_TOOLS') {
          s.subNavigation.forEach((d, i) => {
            if (d.hideInProd) {
              s.subNavigation.splice(i, 1);
            }
          })
        }
      }))
    }
    const linksToExclude = this.getLinksToExclude();
    this.menuList.leftTopNavigation = this.filterByUserRole(userPermissions, MenuItemsArray.leftTopNavigation, linksToExclude)
    this.menuList.leftMidNavigation = this.filterByUserRole(userPermissions, MenuItemsArray.leftMidNavigation, linksToExclude)
    this.menuList.leftBottomNavigation = this.filterByUserRole(userPermissions, MenuItemsArray.leftBottomNavigation, linksToExclude)
    const isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
    if (isE3DChina) {
      this.menuList.leftTopNavigation.forEach(nav=>{
        var hasRI=nav.subNavigation.find(item=>item.breadcrumb==="Recycle Intelligence");
        if(hasRI){
          nav.subNavigation.push({
            breadcrumb: "Digital Intelligence",
            hover: "Digital Intelligence",
            isSelected:false,
            label:"数智汇",
            labelMobile:"数智汇",
            link:"/digital-intelligence",
            text: '数智汇',
            name:"Navigation - Main - Digital Intelligence"
          })
          nav.subNavigation=nav.subNavigation.filter(item=>item.breadcrumb!="Recycle Intelligence")
        }
        
      })
    
    }
    this.hideMenuItems();
    this.getToolsMenus();
    this.getDigitalServicesMenu();
    setTimeout(() => {
      this.sortMenuItems();
      this.cdr.markForCheck();
    }, 300); // 300ms delay to give files time to load
  }

  /**
   * Handles navigation when the "Navigate to AWS" option is clicked.
   *
   * - Sets cookies for manual redirection and target host.
   * - Redirects the browser to the selected cloud environment.
   *
   * @function navigateToAWSClicked
   * @param {SelectedMenus} event - The menu selection event triggering navigation.
   * @returns {void}
   */
    navigateToAWSClicked(event: SelectedMenus) {
      document.cookie = 'manualredirection=true; path=/; Secure';
      document.cookie = `host=${this.targetCloud}; path=/; Secure`;
      window.location.href = `${window.location.origin}`;
    }

  private sortMenuItems(): void {
    if (this.menuList) {
      // Sort leftTopNavigation
      if (this.menuList.leftTopNavigation) {
        this.menuList.leftTopNavigation = this.sortMenuItemsByLabel(this.menuList.leftTopNavigation);
      }

      // Sort leftMidNavigation
      if (this.menuList.leftMidNavigation) {
        this.menuList.leftMidNavigation = this.sortMenuItemsByLabel(this.menuList.leftMidNavigation);
      }

      // Sort leftBottomNavigation
      if (this.menuList.leftBottomNavigation) {
        this.menuList.leftBottomNavigation = this.sortMenuItemsByLabel(this.menuList.leftBottomNavigation);
      }
    }
  }
  
  private stripHtmlTags(text: string): string {
    if (!text) return '';
    return text.replace(/<[^>]*>/g, '').trim();
  }

  private sortMenuItemsByLabel(menuItems: MenuItems[]): MenuItems[] {
    if (!menuItems || menuItems.length === 0) return menuItems;
    
    return menuItems.sort((a, b) => {
      // Use text property if it exists, otherwise fall back to label
      const rawTextA = a.text || a.label || '';
      const rawTextB = b.text || b.label || '';

      // Strip HTML tags and normalize for comparison
      const textA = this.stripHtmlTags(this.translation.instant(rawTextA)).toLowerCase().trim();
      const textB = this.stripHtmlTags(this.translation.instant(rawTextB)).toLowerCase().trim();

      // Handle empty strings by putting them at the end
      if (!textA && !textB) return 0;
      if (!textA) return 1;
      if (!textB) return -1;
      
      return textA.localeCompare(textB, undefined, { 
      numeric: true, 
      sensitivity: 'base',
      ignorePunctuation: true 
      });
    }).map(item => {
      // If the item has subNavigation, sort it recursively
      if (item.subNavigation && item.subNavigation.length > 0) {
      item.subNavigation = this.sortMenuItemsByLabel(item.subNavigation);
      }
      return item;
    });
  }

  /**
 * Sets visibility of cloud navigation based on user access and environment.
 *
 * - If the user lacks cloud instance switch access, hides the navigation.
 * - If the user has access and is in "azure", shows navigation to AWS.
 * - If the user has access and is in "aws", shows navigation to Azure.
 * - Otherwise, hides the navigation.
 *
 * @private
 * @function setCloudNavigationVisibility
 * @returns {void}
 */

  private setCloudNavigationVisibility() {
    const hasCloudInstanceSwitchPermission = this.hasCloudInstanceSwitchAccess();
    const cloud = this.config.getEnv('cloudEnv').toString();

    if (!hasCloudInstanceSwitchPermission) {
      this.showCloudInstanceNavigation = false;
      return;
    }

    const activeOption = this.cloudOptions.find(o => o.id === cloud.toLowerCase());
    this.currentCloudLabel = `ECOLAB3D on ${activeOption!.label}`;
    this.cloudOptions = this.cloudOptions.map(o => ({ ...o, active: o.id === activeOption?.id }));
    this.showCloudInstanceNavigation = true;
  }

  toggleCloudDropdown() {
    this.showCloudDropdown = !this.showCloudDropdown;
  }

  selectCloudOption(option: CloudOption) {
    if (!option.targetPath) { return; }
    this.showCloudDropdown = false;
    if (option.active) { return; }
    this.cloudOptions = this.cloudOptions.map(o => ({ ...o, active: o.id === option.id }));
    this.targetCloud = option.targetPath;
    this.navigateToAWSClicked({} as SelectedMenus);
  }


/**
 * Checks whether the current user has access to switch cloud instances.
 *
 * @private
 * @function hasCloudInstanceSwitchAccess
 * @returns {boolean} True if the user has access to switch cloud instances, otherwise false.
 */
  private hasCloudInstanceSwitchAccess(): boolean {
    const user: UserSettings = this.userService.getCurrentSettings();
    let hasCloudInstanceSwitchPermission = this.getUserPermission(user, [USERROLES.SWITCH_CLOUD_INSTANCE]);
    return hasCloudInstanceSwitchPermission;
  }

  
/**
 * Determines if the given user has a specific permission.
 *
 * @private
 * @function getUserPermission
 * @param {UserSettings} user - The current user’s settings object.
 * @param {string[]} permissionIds - The permission IDs to check against.
 * @returns {boolean} True if the user has the permission, otherwise false.
 */
  private getUserPermission(user: UserSettings, permissionIds: string[]): boolean {
    return user.Permissions.some((p) => permissionIds.includes(p.PermissionId.toString()));
  }

  hideMenuItems() {
    if (this.isClimateIntelligenceNavigation == "false") {
      this.menuList.leftTopNavigation.forEach((s, index) => {
        if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
          s.subNavigation.forEach((d, i) => {
            if (d.label === 'LEFT_NAV.SUBNAV_CLIMATE.NAV_LABEL') {
              this.menuList.leftTopNavigation[index].subNavigation.splice(i, 1)
            }
          })
        }
      });
    }
    if (this.isCrudeFlexEnabled === "false") {
      this.menuList.leftTopNavigation.forEach((s, index) => {
        if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
          s.subNavigation.forEach((d, i) => {
            if (d.label === 'LEFT_NAV.SUBNAV_CRUDE_FLEX_CORPORATION.NAV_LABEL') {
              this.menuList.leftTopNavigation[index].subNavigation.splice(i, 1)
            }
          })
        }
      });
    }
    if (this.isFSQSEnabled === "false") {
      this.menuList.leftTopNavigation.forEach((s, index) => {
        if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
          s.subNavigation.forEach((d, i) => {
            if (d.label === 'LEFT_NAV.SUBNAV_FSQS.NAV_LABEL') {
              this.menuList.leftTopNavigation[index].subNavigation.splice(i, 1)
            }
          })
        }
      });
    }
    if (!this.isTotalBoothManagementEnabled) {
      this.menuList.leftTopNavigation.forEach((s, index) => {
        if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
          s.subNavigation.forEach((d, i) => {
            if (d.label === 'LEFT_NAV.SUBNAV_TOTAL_BOOTH_MANAGEMENT.NAV_LABEL') {
              this.menuList.leftTopNavigation[index].subNavigation.splice(i, 1)
            }
          })
        }
      });
    }
    if (!this.isPaperServiceEnabled) {
      this.menuList.leftTopNavigation.forEach((s, index) => {
        if (s.label === 'LEFT_NAV.MAIN_NAV_LABEL') {
          s.subNavigation.forEach((d, i) => {
            if (d.label === 'LEFT_NAV.SUBNAV_PAPER.NAV_NAME') {
              this.menuList.leftTopNavigation[index].subNavigation.splice(i, 1)
            }
          })
        }
      });
    }
    // code is commented ,Logic is no more required
    // if (!this.isCredentialMenuHide) { 
    //   this.navigationMenu.leftNavigation.forEach((s, index) => {
    //     if (s.label === 'LEFT_NAV.ADMIN_NAV_LABEL') {
    //       s.subNavigation.forEach((d, i) => {
    //         if (d.label === 'LEFT_NAV.SUBNAV_CREDENTIAL_MANAGEMENT.NAV_LABEL') {
    //           this.navigationMenu.leftNavigation[index].subNavigation.splice(i, 1)
    //         }
    //       })
    //     }
    //   });
    // }
  }
  navigateToExternal(navigationItem: any){
    if (navigationItem.breadcrumb === 'Ecolab<sup>&reg</sup> CIP IQ&trade;') {
      const isE3DChina = (this.config.getEnv("IsE3DChina") === "true") ? true : false;
      if(isE3DChina){
        window.open(environment.CIP_LINK_China);
      }else{
        window.open(environment.CIP_LINK);
      }
    }
    else if (navigationItem.breadcrumb === 'eCommerce') {
      window.open(environment.E_Commerce);
    }
    else if (navigationItem.breadcrumb === 'E-data-workaround') {
      // Adding this condition to navigate to new E-Data Entry page only on QA.
      if(this.isEDataEntryNavigation == "true"){
        this.router.navigate(['/e-data-entry']);
      } else {
        window.open(environment.Envision_EData_Workaround);
      }
    }
    else if(navigationItem.breadcrumb === 'Wash Process Intelligence') {
      window.open(environment.Water_Process_Intelligence);
    }
    else if (navigationItem.isExternal) {
      window.open(environment[navigationItem.link]);
    }    
  }

  /**
 * @description Get the digital services menus as per roles
 * 
 */


  getDigitalServicesMenu():void{
     const isGovInstance = this.config.getEnv("isGov");
    this.digitalServicesMenu = [];
    this.menuList.leftTopNavigation.forEach(menu => {
      if (menu.text === 'LEFT_NAV.MAIN_NAV_LABEL') {
       if (isGovInstance) {
        this.digitalServicesMenu = menu.subNavigation.filter(item => item.isGOV === true);
      } else {
        this.digitalServicesMenu = menu.subNavigation;
      }
      }
    });
  }



  /**
   * @description Get the tools menus as per the slice method
   * 
   */

  getToolsMenus(){
    this.toolsMenus = [];
    this.leftMidNavigationItems = [];
    this.menuList.leftMidNavigation.forEach(menu => {
      if (menu.text === 'LEFT_NAV.MAIN_NAV_TOOLS') {
        this.leftMidNavigationItems = menu.subNavigation
        if (menu.subNavigation.length > 6) {
          this.toolsMenus = menu.subNavigation.slice(0, 6)
          this.isexpanded = false;
        } else {
          this.toolsMenus = menu.subNavigation;
          this.isexpanded = false;
        }
      }
    });
  }


  /**
   * @description Expand the accordian on click by user
   */


  expandAccordian(){
    this.toolsMenus = this.leftMidNavigationItems;
    this.isexpanded = true;

  }

  /**
 * Determines whether to hide services based on the current cloud environment.
 *
 * If the environment is set to "aws" (case-insensitive), it sets
 * `this.hideServicesForAWS` to `true`. Otherwise, it sets it to `false`.
 *
 * @function hideServicesforAWSInstance
 * @returns {void} This function does not return a value; it updates the
 *                 `hideServicesForAWS` property of the current instance.
 */
  hideServicesforAWSInstance() {
    const cloud = environment.cloudEnv;
    if (cloud.toLowerCase() == this.azure) {
      this.hideServicesForAWS = false;
    }
    else {
      this.hideServicesForAWS = true;
    }
  }

}
